// The `dictation/preferences` api module — carved from
// `src/features/dictationLogs/api.ts` (now a re-export delegate) at D1 slice 1,
// ARCFE-1067.
//
// WHY THIS FILE COULD MOVE AND THE LOGS HALF COULD NOT. The P0 census recorded
// D1 as blocked on the t11nClient split, and for the logs family that is still
// exactly true: its five fns are a tail block INSIDE
// `@/lib/SessionRecordingProvider/t11nClient.ts` and its four hooks import them
// by value. This family never touched that module. Its three fns were already a
// standalone api module over `scribeHttpV2`, and its only boundary blocker was
// `@/utils/scribeHTTP` — the agents 4.1 blocker, with the same shipped heal
// (`@heidi/api/client`, E5/ARCFE-805). Measured per file at ARCFE-1067; the
// table is in the PR body and the lane record.
//
// The registry's transport is the app's REAL `scribeHttpV2` singleton — same
// interceptors, same auth/refresh state — so request behaviour is byte-identical
// to the pre-move module. `ScribeHttp` keeps the signatures structural: no axios
// type reaches this package's surface, and `axios` stays out of its manifest.
//
// The file is named for its FAMILY rather than keeping the source basename
// `api.ts`, which would have landed as `data/api/api.ts`. That is a deliberate,
// disclosed deviation from the keep-the-original-basename rule: the package
// already partitions `/contracts` on the family line (`preferences.types.ts`,
// `preferences-query-keys.ts`), and every sibling package names api modules by
// topic (`commerce/data/api/products.ts`, `agents/data/api/agent-memory.ts`).
// The hooks below keep their exact basenames, which is where that rule bites —
// they are the `jest.mock` targets.
import { getScribeHttpClients } from '@heidi/api/client';

import type {
  DictationAppCategoriesResponse,
  DictationAppCategoryResponse,
  DictationTone,
  VerbalCommandsLanguagesResponse,
} from '../../contracts';

interface ScribeHttp {
  get<T>(url: string): Promise<{ data: T }>;
  patch<T>(url: string, body?: unknown): Promise<{ data: T }>;
}

// `scribeHttpV2` base is /api/v2/ml-scribe/; scribe JWT injected by interceptor.
const http = (): ScribeHttp => getScribeHttpClients().scribeHttpV2;

export const getDictationAppCategories = async () => {
  const response = await http().get<DictationAppCategoriesResponse>(
    '/dictation/app-categories'
  );
  return response.data;
};

export const getVerbalCommandsLanguages = async () => {
  const response = await http().get<VerbalCommandsLanguagesResponse>(
    '/dictation/verbal-commands-languages'
  );
  return response.data;
};

export const patchDictationAppCategoryTone = async (
  categoryId: string,
  tone: DictationTone
) => {
  const response = await http().patch<DictationAppCategoryResponse>(
    `/dictation/app-categories/${categoryId}`,
    { tone }
  );
  return response.data;
};
